

export const ProductTypeData = [
  { "label": "CSFMU-S" },
  { "label": "CSFMU-B" },
  { "label": "F&V" },
  { "label": "FMU-D" },
  { "label": "HEXT" },
  { "label": "PCG" },
  { "label": "REXT" },
  { "label": "OEXT" },
  { "label": "PCG-CSFMU-S" },
  { "label": "PCG-CSFMU-B" },
  { "label": "SHXTO" },
  { "label": "EHXTO" },
  { "label": "Liquid EXT-S" },
  { "label": "Liquid EXT-B" },
  { "label": "SDNP" },
  { "label": "SDNP-L" }
];

export const CNProductTypeData = [
  { "label": "TY-EHXTO" },
  { "label": "TY-L" },
  { "label": "TY-P" },
  { "label": "TY-SHXTO" }
];

export const CoaProductTypeData = [
  { "label": "Powder" },
  { "label": "Liquid" },
  { "label": "EHXTO" },
  { "label": "SHXTO" },
]

export const CnCoaProductTypeData = [
  { "label": "TY-P" },
  { "label": "TY-L" },
  { "label": "TY-EHXTO" },
  { "label": "TY-SHXTO" },
]

export const PhysicalPropertiesData = [
  { "label": "Blend" },
  { "label": "Single" },
  { "label": "Granulate" },
  { "label": "Liquid" },
  { "label": "Oil" },
  { "label": "Essential oil" },
  { "label": "Glycerin" }
];

export const MeshSizeOptionsData = [
  { "label": "80-100 Mesh" },
  { "label": "20 Mesh" },
  { "label": "10 Mesh" },
  { "label": ">95% pass 80 Mesh" }
]

export const CarrierOptionsData = [
  { "label": "None" },
  { "label": "Maltodextrin" }
]

export const CNCarrierOptionsData = [
  { "label": "无" },
  { "label": "麦芽糊精" }
]

export const AppearanceOptionsData = [
  { "label": "Oil" },
  { "label": "Viscous liquid" },
  { "label": "Liquid" },
  { "label": "Powder" },
  { "label": "Granular" }
]

export const CNAppearanceOptionsData = [
  { "label": "液体" },
  { "label": "粉末" },
  { "label": "颗粒" },
  { "label": "粘稠油状液体" }
]

export const GeneralSpecificationColorData = [
  { label: "Light brown" },
  { label: "Light yellow to yellow" },
  { label: "Light yellow to brownisn yellow" },
  { label: "Light reddish brown to dark brownish red" },
  { label: "Red" }
]

export const ShelflifeNumberData = [
  { label: "12" },
  { label: "18" },
  { label: "24" },
  { label: "36" },
]

export const NotesDefaultData = [
  {
    type: ["HEXT", "F&V", "CSFMU-B", "CSFMU-S", "FMU-D", "PCG", "PCG-CSFMU-S", "PCG-CSFMU-B", "OEXT", "REXT", "SDNP"],
    content: ["* Color variation from batch to batch of the product may occur due to natural variations of raw material.",
      "* The pH of powder product should be tested in its 1% aqueous solution if necessary."]
  },
  {
    type: ["SHXTO", "EHXTO"],
    content: ["* Color variation from batch to batch of the product may occur due to natural variations of raw material.",
      "* Some natural sediment may occur upon standing, that does not compromise the quality of the product; please warm to ambient temperature and mix well before use in such case."]
  },
  {
    type: ["Liquid EXT-S", "Liquid EXT-B", "SDNP-L"],
    content: ["* Color variation from batch to batch of the product may occur due to natural variations of raw material.",
      "* Some natural sediment may occur upon standing, that does not compromise the quality of the product; please warm to ambient temperature and mix well before use in such case.",
      "* The pH of liquid product should be tested in its 1% aqueous solution if the liquid product contains less than 50% water."]
  }
]

export const CNNotesDefaultData = [
  {
    type: ["TY-P"],
    content: ["* 不同批次产品的颜色可能会因天然原材料的自然变化而产生差异。",
      "* 产品含抗氧化化合物，可能会随着时间推移颜色变深但不影响使用效果。（可选打印）",
      "* 必要情况下，产品的pH 值应该在1%该产品的水溶液中测定。"]
  }, {
    type: ["TY-L"],
    content: ["* 不同批次产品的颜色可能会因天然原材料的自然变化而产生差异。",
      "* 产品含抗氧化化合物，可能会随着时间推移颜色变深但不影响使用效果。（可选打印）",
      "* 天然植物产品在长期静置时可能会产生一些产品本身的沉淀物，这不会影响产品的质量；如发现产品有沉淀，请在使用前适当加热并搅拌至充分混合。",
      "* 如果产品中含水量低于50%，则产品的 pH 值必须在1%产品的水溶液中测定。"]
  }, {
    type: ["TY-EHXTO", "TY-SHXTO"],
    content: ["* 不同批次产品的颜色可能会因天然原材料的自然变化而产生差异。",
      "* 产品含抗氧化化合物，可能会随着时间推移颜色变深但不影响使用效果。（可选打印）",
      "* 天然植物产品在长期静置时可能会产生一些产品本身的沉淀物，这不会影响产品的质量；如发现产品有沉淀，请在使用前适当加热并搅拌至充分混合。"]
  }
]

export const CoaENAditionalText={
  "note1": "Manufacturing Site: Shanghai Tianyuan Plant Products Company, Ltd. No.18 Hexiang Rd, Baihe Town, Qingpu District, Shanghai.",
  "note2": "The above listed product is non-irradiated product.",
  "note3": "Disclaimer: This product is intended only for animal use and is not intended for human consumption."
}

export const CoaENNotes = [
  {
    type: ["EHXTO",'SHXTO'],
    content: [
      "* Color variation from batch to batch of the product may occur due to natural variations of raw material.",
      "* Some natural sediment may occur upon standing, that does not compromise the quality of the product; please warm to ambient temperature and mix well before use in such case.",
    ]
  },{
    type: ["Powder"],
    content: [
      "* Color variation from batch to batch of the product may occur due to natural variations of raw material.",
      "* The pH of powder product should be tested in its 1% aqueous solution if necessary.",
    ]
  },{
    type: ["Liquid"],
    content: [
      "* Color variation from batch to batch of the product may occur due to natural variations of raw material.",
      "* Some natural sediment may occur upon standing, that does not compromise the quality of the product; please warm to ambient temperature and mix well before use in such case.",
      "* The pH of liquid product should be tested in its 1% aqueous solution if the liquid product contains less than 50% water."
    ]
  }
]

export const CoaCNNotes = [
  {
    type: ["TY-P"],
    content: ["* 不同批次产品的颜色可能会因天然原材料的自然变化而产生差异。",
      "* 必要情况下，产品的pH 值应该在1%该产品的水溶液中测定。"
    ]
  },
  {
    type: ["TY-L"],
    content: ["* 不同批次产品的颜色可能会因天然原材料的自然变化而产生差异。",
        "* 天然植物产品在长期静置时可能会产生一些产品本身的沉淀物，这不会影响产品的质量；如发现产品有沉淀，请在使用前适当加热并搅拌至充分混合。",
        "* 如果产品中含水量低于50%，则产品的 pH 值必须在1%产品的水溶液中测定。"
    ]
  },
  {
    type: ["TY-EHXTO","TY-SHXTO"],
    content: ["* 不同批次产品的颜色可能会因天然原材料的自然变化而产生差异。",
        "* 天然植物产品在长期静置时可能会产生一些产品本身的沉淀物，这不会影响产品的质量；如发现产品有沉淀，请在使用前适当加热并搅拌至充分混合。"
    ]
  },

]

/**
 * 根据语言和类型获取对应的内容
 * @param {string} language - 语言类型 ('en' | 'cn')
 * @param {string} type - 内容类型 ('spec' | 'coa')
 * @param {string} productType - 产品类型
 * @returns {Array} 返回对应的内容数组
 */
export const getContentByLanguageAndType = (language, type, productType) => {
  // 数据映射配置
  const dataMapping = {
    en: {
      spec: NotesDefaultData,
      coa: CoaENNotes
    },
    cn: {
      spec: CNNotesDefaultData,
      coa: CoaCNNotes
    }
  };

  // 获取对应的数据源
  const dataSource = dataMapping[language]?.[type];
  
  if (!dataSource) {
    console.warn(`未找到对应的数据源: language=${language}, type=${type}`);
    return [];
  }

  // 查找匹配的产品类型
  const matchedData = dataSource.find(item => 
    item.type && item.type.includes(productType)
  );

  if (!matchedData) {
    console.warn(`未找到产品类型 ${productType} 对应的内容`);
    return [];
  }

  return matchedData.content || [];
};

/**
 * 获取COA附加文本
 * @param {string} language - 语言类型 ('en' | 'cn')
 * @returns {Object} 返回对应的附加文本对象
 */
export const getCoaAdditionalText = (language) => {
  const additionalTextMapping = {
    en: CoaENAditionalText,
    cn: {
      note1: "生产地址：上海天源植物制品有限公司，上海市青浦区白鹤镇河西路18号。",
      note2: "上述产品为非辐照产品。",
      note3: "免责声明：本产品仅供动物使用，不适用于人类食用。"
    }
  };

  return additionalTextMapping[language] || {};
};

/**
 * 获取产品类型数据
 * @param {string} language - 语言类型 ('en' | 'cn')
 * @param {string} type - 数据类型 ('spec' | 'coa')
 * @returns {Array} 返回对应的产品类型数据
 */
export const getProductTypeData = (language, type) => {
  const productTypeMapping = {
    en: {
      spec: ProductTypeData,
      coa: CoaProductTypeData
    },
    cn: {
      spec: CNProductTypeData,
      coa: CnCoaProductTypeData
    }
  };

  return productTypeMapping[language]?.[type] || [];
};

export const ProductDescriptionOptions = {
  "CSFMU-B": {
      "水提": "水提B product_description",
      "酶解": "酶解B product_description",
      "超临界": "超临界B product_description",
  },
  "CSFMU-S": {
    "水提": "水提 product_description",
    "酶解": "酶解 product_description",
    "超临界": "超临界 product_description",
  },
  "F&V": {
    "水提": "水提 product_description",
  },
  "FMU-D": {
    "水提": "水提 product_description",
  },
  "HEXT": {
    "水提": "水提 product_description",
  },
  "PCG": {  
    "水提": "水提 product_description",
  },
  "REXT": {
    "水提": "水提 product_description",
  },
  "OEXT": {
    "水提": "水提 product_description",
  },
}